import { format } from 'date-fns';
import type { Filters } from 'hooks/store/stock-balance';
import type { FormSchema } from './formSchema';

const f = (date: Date) => {
  return format(date, 'yyyy-MM-dd');
};

export const createReportParams = ({
  formData,
  stockTypes,
  columns,
}: {
  formData: FormSchema;
  stockTypes?: string[];
  columns?: string[];
}): Record<string, unknown> => {
  const { invoiceNumber, productIds, companyIds, expirationDate } = formData;

  return {
    ...(invoiceNumber && { invoiceNumber }),
    ...(productIds?.length && { productIds: productIds.toString() }),
    ...(companyIds?.length && { companyIds: companyIds.toString() }),
    ...(expirationDate?.from && {
      expirationDateStart: f(expirationDate.from),
    }),
    ...(expirationDate?.to && {
      expirationDateEnd: f(expirationDate.to),
    }),
    ...(stockTypes?.length && { stockTypes: stockTypes.toString() }),
    ...(columns?.length && { columns }),
  };
};

export const createFilterParams = ({
  formData,
  stockTypes,
}: {
  formData: FormSchema;
  stockTypes?: string[];
}): Filters => {
  const { expirationDate, ...rest } = formData;

  return {
    ...rest,
    ...(expirationDate?.from && { expirationDateStart: f(expirationDate.from) }),
    ...(expirationDate?.to && { expirationDateEnd: f(expirationDate.to) }),
    ...(stockTypes?.length && { stockTypes }),
  };
};
